import {
  chatGetFeedPostsForUser,
  getChatGetFeedPostsForUserQueryKey,
} from "@/orval/gen"
import { DefaultInfiniteList } from "../../../../../-components/InfiniteList"
import { useDefaultSuspenseInfiniteQuery } from "../../../../../utils/useDefaultSuspenseInfiniteQuery"
import { FeedPostCard } from "./FeedPostCard"

interface Props {
  subscribed: boolean
}

export function FeedPostsForUserList({ subscribed }: Props) {
  return (
    <DefaultInfiniteList
      gap="md"
      align="center"
      queryResult={useDefaultSuspenseInfiniteQuery(
        chatGetFeedPostsForUser,
        (pageRequest) => ({
          ...pageRequest,
          subscribed,
        }),
        {
          queryKey: getChatGetFeedPostsForUserQueryKey({ subscribed }),
        }
      )}
      renderItem={({ entity }) => (
        <FeedPostCard hideComments feedPost={entity} />
      )}
    />
  )
}
